/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Cc_CapacityInputs */

const en_cc_capacity = /** @type {(inputs: Cc_CapacityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`capacity ${i?.count}`)
};

const id_cc_capacity = /** @type {(inputs: Cc_CapacityInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`kapasitas ${i?.count}`)
};

/**
* | output |
* | --- |
* | "capacity {count}" |
*
* @param {Cc_CapacityInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cc_capacity = /** @type {((inputs: Cc_CapacityInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cc_CapacityInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cc_capacity(inputs)
	return en_cc_capacity(inputs)
});